import { render, staticRenderFns } from "./GireseMge.vue?vue&type=template&id=10fb70e7&scoped=true&"
import script from "./GireseMge.vue?vue&type=script&lang=js&"
export * from "./GireseMge.vue?vue&type=script&lang=js&"
import style0 from "./GireseMge.vue?vue&type=style&index=0&id=10fb70e7&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fb70e7",
  null
  
)

export default component.exports